import { Stack } from '@mui/material';
import { FC } from 'react';
import { useGetOne } from 'react-admin';

import { GetInstrumentsResponseItem } from '@Common/types/bo/instruments';

import { B2bInvestorProfileGridColumnHeader } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/components/B2bInvestorProfileGridColumn/components/B2bInvestorProfileGridColumnHeader/B2bInvestorProfileGridColumnHeader';
import { B2bInvestorProfileGridColumnTextInput } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/components/B2bInvestorProfileGridColumn/components/B2bInvestorProfileGridColumnTextInput/B2bInvestorProfileGridColumnTextInput';
import { InvestorProfileGridInstrumentAllocation } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/helpers/transformBoGridToFormGrid';

interface Props {
  allocation: InvestorProfileGridInstrumentAllocation;
  columnIdx: number;
}

export const B2bInvestorProfileGridColumn: FC<Props> = (props) => {
  const { allocation, columnIdx } = props;

  const { data: instrument } = useGetOne<GetInstrumentsResponseItem>('instruments', {
    id: allocation.instrument_id,
  });

  if (!instrument) {
    return null;
  }

  return (
    <Stack spacing={1.5}>
      <B2bInvestorProfileGridColumnHeader
        instrumentName={instrument.name ?? ''}
        instrumentIsin={instrument.isin ?? ''}
      />
      {allocation.allocation.map((_, rowIdx) => (
        <B2bInvestorProfileGridColumnTextInput
          key={`${columnIdx}-${rowIdx}`}
          rowIdx={rowIdx}
          columnIdx={columnIdx}
          testId="BoExternalB2bInvestorProfileGridColumn_TextInput"
        />
      ))}
    </Stack>
  );
};
